<template>
  <form-panel
    id="cities-cost-of-living"
    title="Cost of Living"
    panel-content-class="pb-6 mb-6"
    panel-button-text-class="tracking-normal"
  >
    <template #content>
      <div
        class="flex w-full flex-wrap justify-between justify-items-center rounded-sm border border-gray-300 bg-white px-8 py-4 text-base"
      >
        <div class="mt-3 w-full xs:w-6/12 md:w-4/12">
          <h4 class="font-semibold text-gray-700">Books (Semester)</h4>
          <p class="mt-2" data-cy="sidebar-city-name-label">
            $&emsp;{{ props.data?.average_semester_books || "Not provided" }}
          </p>
        </div>
        <div class="mt-3 w-full xs:w-6/12 md:w-4/12">
          <h4 class="font-semibold text-gray-700">Transportation (Daily)</h4>
          <p class="mt-2" data-cy="sidebar-city-name-label">
            $&emsp;{{
              props.data?.average_daily_local_transport || "Not provided"
            }}
          </p>
        </div>
        <div class="mt-3 w-full xs:w-6/12 md:w-4/12 lg:w-80">
          <h4 class="font-semibold text-gray-700">Expenses (Daily)</h4>
          <p class="mt-2" data-cy="sidebar-city-name-label">
            $&emsp;{{
              props.data?.average_daily_personal_expenses || "Not provided"
            }}
          </p>
        </div>
        <div class="mt-3 w-full xs:w-6/12 md:w-4/12">
          <h4 class="font-semibold text-gray-700">Meal (Daily)</h4>
          <p class="mt-2" data-cy="sidebar-city-name-label">
            $&emsp;{{ props.data?.average_daily_meals || "Not provided" }}
          </p>
        </div>
      </div>
    </template>
  </form-panel>
</template>

<script setup>
import formPanel from "@/components/forms/SharedComponents/panel.vue";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});
</script>
